export default "__VITE_ASSET__4_y3YBxy__"